import React from "react";

function Turtle() {
  return (
    <div className="gif-background">
      <img
        className="turtle"
        alt="Turtle GIF"
        src="./ocean/turtle.png"
        style={{ left: "5vw" }}
      />
    </div>
  );
}

export default Turtle;
